import { Client } from './client';

export class OrderBilling {
  businessName: string = null;
  client: Client = null;
}
